var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"g-progress-bar"},[_c('div',{staticClass:"progress",style:({ width: `${_vm.progress * 100}%` })})])
}
var staticRenderFns = []

export { render, staticRenderFns }